/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Task assignee type enumeration
 */
export enum TaskAssigneeType {
    USER = 'user',
    AI_EMPLOYEE = 'ai_employee',
}
